import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import pluralize from 'pluralize';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import AssociatedProjectSelector from '../tasks/associated_project_selector';
import Errors from 'components/form/errors.js';

export default class CreateProjectContactRoleModal extends React.Component {
  static propTypes = {
    contactLabel: PropTypes.string.isRequired,
    relationships: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    selectedContactCount: PropTypes.number.isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  state = {
    errors: null,
    project: null,
    relationship: this.props.relationships[0]
  }

  handleRelationshipChange = relationship => this.setState({ errors: null, relationship })
  handleProjectSelect = project => this.setState({ errors: null, project })
  handleProjectClear = () => this.setState({ errors: null, project: null })
  canSubmit = () =>  !!this.state.project;

  handleCancel = () => {
    this.setState({
      errors: null,
      project: null
    }, () => {
      this.props.onCancel();
    });
  }

  handleSubmit = () => {
    const { relationships, onSubmit } = this.props;
    const { project, relationship } = this.state;

    this.canSubmit() && onSubmit(project.associatedModelId, relationship.id).then(() => {
      this.setState({ errors: null, project: null, relationship: relationships[0] });
    }).catch(errors => this.setState({ errors }));
  }

  count = withNumber => pluralize(this.props.contactLabel, this.props.selectedContactCount, !!withNumber)

  render() {
    const { shown } = this.props;
    const { errors, project } = this.state;
    return (
      <Modal className="lead-modal" show={shown} onHide={this.handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Add {this.count(true)} to Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors && <Errors errors={errors} />}
          {project && project.associatedModelId ? this.renderProjectSelected() : this.renderProjectSelector()}

          <label>Relationship</label>
          <Select
            name="relationship"
            options={this.props.relationships}
            value={this.state.relationship}
            onChange={this.handleRelationshipChange}
          />

        </Modal.Body>
        <Modal.Footer>
          {this.renderButtons()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderButtons() {
    return (
      <div className="pull-left">
        <button className="btn btn-sm btn-cancel mr-3" onClick={this.handleCancel}>Cancel</button>
        {this.canSubmit() ? this.renderSubmitButton() : this.renderWithTooltip(this.renderSubmitButton(), 'top')}
      </div>
    );
  }

  renderWithTooltip = (button, placement) => {
    const message = !this.state.project && 'Project can not be blank';
    const tooltip = <Tooltip id="disable-save-button">{message}</Tooltip>;

    return (
      <OverlayTrigger overlay={tooltip} placement={placement}>
        <span className="d-inline-block">{button}</span>
      </OverlayTrigger>
    );
  }

  renderSubmitButton() {
    const disabled = !this.canSubmit();
    return (
      <button
        className="btn btn-sm btn-save"
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        onClick={this.handleSubmit}
      >
        Add {this.count()} to Project
      </button>
    );
  }

  renderProjectSelected() {
    return (
      <span>
        You are about to add <strong>{this.count(true)}</strong> to the following project:
        <h3 className="top-buffer-sm mb-0">
          {this.state.project.name}
          <FontAwesomeIcon
            className="left-buffer-md text-danger clickable"
            icon={faTimes}
            size="sm"
            onClick={this.handleProjectClear}
          />
        </h3>
        <p className="top-buffer-xs bottom-buffer-sm text-muted">{this.state.project.address}</p>
      </span>
    );
  }

  renderProjectSelector() {
    return (
      <React.Fragment>
        <label>Select Project</label>
        <AssociatedProjectSelector onModelAdded={this.handleProjectSelect} />
      </React.Fragment>
    );
  }
}
